import axios from 'axios';

export default{
    requestSubscribers(type, form) {
        if (type == 'put') {
            return axios.put(`${process.env.API_URL}/email-subscribers/${form.id}`, form);
        }
        else if (type == 'post') {
            return axios.post(`${process.env.API_URL}/email-subscribers`, form);
        } else if (type == 'delete') {
            return axios.delete(`${process.env.API_URL}/email-subscribers/${form.id}`);
        }
        else {
            return axios.get(`${process.env.API_URL}/email-subscribers`);
        }
    },
}


// WEBPACK FOOTER //
// ./src/Apis/emailSubscribers.js